import React from 'react';

const SIZES = { small: '24px', medium: '48px', large: '80px', xlarge: '120px' };

const SpacerBlock = ({ content = {}, settings = {} }) => {
  const { height = 'medium' } = content;
  const { backgroundColor = 'transparent' } = settings;
  return <div style={{ height: SIZES[height] || height, backgroundColor }} />;
};

export default SpacerBlock;
